export const overviewModels = [
  {
    id: "model-city",
    name: "城市模型",
    categoryCount: 4,
    datasetCount: 2,
    trained: true,
    lastTrainTime: "2026/8/26",
  },
  {
    id: "model-person",
    name: "人物模型",
    categoryCount: 3,
    datasetCount: 1,
    trained: true,
    lastTrainTime: "2026/8/20",
  },
  {
    id: "model-company",
    name: "企业模型",
    categoryCount: 4,
    datasetCount: 3,
    trained: false,
    lastTrainTime: "",
  },
];

export const modelCategories = ["政治", "经济", "文化", "生态"];

export const modelInfo = {
  id: "model-city",
  name: "默认模型1",
  type: modelCategories,
  totalArticles: 4820,
};

export const trainCategories = [
  { name: "政治", selected: 1232, target: 1200, docs: 4820 },
  { name: "经济", selected: 1200, target: 1200, docs: 4820 },
  { name: "文化", selected: 1196, target: 1200, docs: 4820 },
  { name: "生态", selected: 1265, target: 1200, docs: 4820 },
];

export const testCategories = [
  { name: "政治", selected: 400, target: 400, docs: 482 },
  { name: "经济", selected: 300, target: 400, docs: 482 },
  { name: "文化", selected: 420, target: 400, docs: 482 },
  { name: "生态", selected: 390, target: 400, docs: 482 },
];

export const trainConfig = {
  epoch: 30,
  learningRate: 0.001,
};

export const trainDataSummary = [
  { label: "训练样本总数", value: "4893 篇" },
  { label: "分类数量", value: "4 类" },
  { label: "遍历次数", value: "30 次" },
  { label: "学习率", value: "0.001" },
  { label: "上次训练时间", value: "2026/10/13 09:24" },
  { label: "训练状态", value: "已完成" },
];

export const trainCategoryStats = [
  { name: "政治", selected: 1232, target: 1200, ratio: "25.2%" },
  { name: "经济", selected: 1200, target: 1200, ratio: "24.5%" },
  { name: "文化", selected: 1196, target: 1200, ratio: "24.4%" },
  { name: "生态", selected: 1265, target: 1200, ratio: "25.9%" },
];

export const trainSampleArticles = [
  {
    id: "t1",
    category: "政治",
    title: "坚持系统观念 不断提升基层治理效能",
    source: "人民日报",
    date: "2026/7/28",
    words: 2740,
    selected: true,
    content:
      "基层治理是国家治理的基石。各地坚持以党建引领基层治理，健全自治、法治、德治相结合的治理体系，把党的政治优势、组织优势转化为治理效能，不断增强群众的获得感与满意度。要善于运用系统观念，统筹各方资源，推动治理重心下移、力量下沉，让基层治理更精准、更高效。",
    keywords: ["基层治理", "系统观念", "党建引领", "治理效能", "德治", "获得感"],
  },
  {
    id: "t2",
    category: "政治",
    title: "全面深化改革开放 激发高质量发展活力",
    source: "新华社",
    date: "2026/7/30",
    words: 3010,
    selected: true,
    content:
      "改革开放是决定当代中国命运的关键一招。要持续深化重点领域改革，稳步扩大制度型开放，以更大力度激发市场活力和社会创造力，为构建新发展格局提供坚实支撑。要坚持问题导向，聚焦体制机制障碍，推动改革举措系统集成、协同高效。",
    keywords: ["改革开放", "高质量发展", "制度型开放", "市场活力", "新发展格局", "体制机制"],
  },
  {
    id: "t3",
    category: "经济",
    title: "多地出台稳经济一揽子政策 助力企业纾困解难",
    source: "经济日报",
    date: "2026/8/6",
    words: 2860,
    selected: true,
    content:
      "今年以来，各地密集出台稳经济一揽子政策措施，从减税降费、金融支持、稳岗就业等方面持续发力，帮助市场主体纾困解难，推动经济运行整体好转，为高质量发展积蓄动能。政策落地见效，关键在精准直达、快速兑现。",
    keywords: ["稳经济", "一揽子政策", "减税降费", "金融支持", "企业纾困", "高质量发展"],
  },
  {
    id: "t4",
    category: "经济",
    title: "绿色发展成为区域经济增长新引擎",
    source: "新华网",
    date: "2026/8/9",
    words: 3120,
    selected: true,
    content:
      "以生态优先、绿色发展为导向，多地加快产业结构调整，推动清洁能源、绿色制造等新兴产业集聚发展，绿色正在成为区域经济高质量发展的鲜明底色，也为经济增长注入新动能。绿色转型不是负担，而是新的发展机遇。",
    keywords: ["绿色发展", "区域经济", "产业结构", "清洁能源", "绿色制造", "新动能"],
  },
  {
    id: "t5",
    category: "文化",
    title: "文化和旅游融合发展释放消费新活力",
    source: "光明日报",
    date: "2026/8/11",
    words: 2410,
    selected: true,
    content:
      "以文塑旅、以旅彰文。各地深入推动文化和旅游融合发展，丰富优质产品供给，打造特色文化品牌，文旅消费潜力持续释放，成为拉动内需、促进就业的重要力量。融合的关键在于挖掘文化内涵，提升旅游体验。",
    keywords: ["文旅融合", "消费活力", "文化品牌", "拉动内需", "以文塑旅", "特色文化"],
  },
  {
    id: "t6",
    category: "生态",
    title: "守护绿水青山 筑牢生态安全屏障",
    source: "中国环境报",
    date: "2026/8/14",
    words: 2680,
    selected: true,
    content:
      "绿水青山就是金山银山。各地持续推进污染防治攻坚，加强生态系统保护修复，筑牢生态安全屏障，推动生态环境质量持续改善。保护生态环境就是保护生产力，改善生态环境就是发展生产力。",
    keywords: ["绿水青山", "生态安全", "污染防治", "保护修复", "生态屏障", "环境质量"],
  },
];